import React from 'react';
import { Button, Popconfirm, Typography } from 'antd';
import type { AdminProductHeaderProps } from '../../interfaces';
import './AdminProductHeader.scss';

const { Title, Text } = Typography;

const AdminProductHeader: React.FC<AdminProductHeaderProps> = ({
  product,
  deletingProductId,
  inventorySummary,
  onDeleteProduct,
}) => (
  <div className="admin-product-form__product-head">
    <div className="admin-product-form__product-summary">
      <div className="admin-product-form__product-thumb">
        {product.images?.[0]?.image?.publicUrl ? (
          <img src={product.images[0].image.publicUrl} alt={product.title} />
        ) : (
          <div className="admin-product-form__product-thumb-placeholder">No image</div>
        )}
      </div>
      <div className="admin-product-form__product-title-block">
        <div className="admin-product-form__product-title-row">
          <Title level={5}>{product.title}</Title>
          <Popconfirm
            title="Delete this product?"
            description="This will also remove related cart items, comments, images, details, and material rows."
            okText="Delete"
            cancelText="Cancel"
            onConfirm={() => void onDeleteProduct(product.id)}
          >
            <Button danger loading={deletingProductId === product.id}>Delete Product</Button>
          </Popconfirm>
        </div>
        <Text type="secondary">
          {product.productType?.name || 'No type'} • {product.gender}
        </Text>
        <div className="admin-product-form__product-metrics" aria-label={`${product.title} inventory summary`}>
          <span><strong>{product.materialPrices.length}</strong> materials</span>
          <span><strong>{inventorySummary.activeMaterialsCount}</strong> active</span>
          {!!inventorySummary.loadedMaterialsCount && (
            <span><strong>{inventorySummary.variantCount}</strong> variants loaded</span>
          )}
          {!!inventorySummary.loadedMaterialsCount && (
            <span><strong>{inventorySummary.totalStock}</strong> stock loaded</span>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default AdminProductHeader;
